import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchPolicies, fetchPoliciesForMultipleUsers } from "../policies/policySlice";
import { logoutUser, setUser } from "../auth/authSlice";
import { incrementActionCounter } from "../../utils/actionCounters";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import 'dayjs/locale/en';
import UploadPolicyModal from "../renewals/UploadPolicy";
import UnifiedPolicyForm from "../addPolicy/UnifiedPolicyForm";
import SuccessDialog from "../addPolicy/SuccessDialog";
import MobileEditAccount from "../auth/MobileEditAccount";
import MobileStaffDialog from "../auth/MobileStaffDialog";
import ShareReportDialog from './ShareReportDialog';
import { auth, db } from "../../firebase/firebaseConfig";
import { updateProfile } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";
// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Fab from '@mui/material/Fab';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from "@mui/material/useMediaQuery";
import Popover from '@mui/material/Popover';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import StatusBadge from "../../components/common/StatusBadge";
import { calculatePolicyStatus, parseDate } from "../../utils/dateUtils";
import { shouldUseMobileLayout } from "../../utils/deviceDetection";
import { useResponsiveFonts, truncateName, truncateText, truncateVehicleModel, truncateVehicleNumber } from "../../utils/responsiveFonts";
import { navigateWithScrollReset, handlePageChangeWithScroll } from "../../utils/ScrollRestoration";
import MobileBottomNavigation from "../../components/common/MobileBottomNavigation";
import { handleMobileRefresh } from "../../utils/mobileRefresh";
import { useAdminStaffData } from "../../hooks/useAdminStaffData";
import { useAccountStatus } from "../../hooks/useAccountStatus";
import RemindDialog from "../../components/common/RemindDialog";
import { COMPANIES } from "../../data/dropdowns";
import { getDriveAuthUrl, checkDriveStatus } from "../../utils/driveApi";
// Icons
import AddIcon from '@mui/icons-material/Add';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SecurityIcon from '@mui/icons-material/Security';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PeopleIcon from '@mui/icons-material/People';
import DescriptionIcon from '@mui/icons-material/Description';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EditIcon from '@mui/icons-material/Edit';
import LogoutIcon from '@mui/icons-material/Logout';
import PhoneIcon from '@mui/icons-material/Phone';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CloudIcon from '@mui/icons-material/Cloud';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

dayjs.extend(weekday);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData);
dayjs.locale('en');

const get = (obj, ...keys) =>
  keys.reduce((acc, k) => (acc !== undefined ? acc : obj?.[k]), undefined);

const MobileRenewals = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { policies, loading, initialized } = useSelector((state) => state.policies);
  const { user } = useSelector((state) => state.auth);
  const { userIds, isAdmin, loading: staffLoading } = useAdminStaffData();
  const { isAccountActive } = useAccountStatus();
  const fonts = useResponsiveFonts();
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs().startOf('week'));
  const [weekDates, setWeekDates] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [prefillData, setPrefillData] = useState(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [successPdfUrl, setSuccessPdfUrl] = useState("");
  const [successPremium, setSuccessPremium] = useState(null);
  const [successBalance, setSuccessBalance] = useState(null);
  const [fabMenuAnchor, setFabMenuAnchor] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [showEditAccount, setShowEditAccount] = useState(false);
  const [showStaffDialog, setShowStaffDialog] = useState(false);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [calendarMonth, setCalendarMonth] = useState(dayjs());
  const [displayedPolicies, setDisplayedPolicies] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [remindDialogOpen, setRemindDialogOpen] = useState(false);
  const [selectedPolicyForRemind, setSelectedPolicyForRemind] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [showStatusOptions, setShowStatusOptions] = useState(false);
  const [showCompanyOptions, setShowCompanyOptions] = useState(false);
  const [showDateRangeCalendar, setShowDateRangeCalendar] = useState(false);
  const [showSingleDay, setShowSingleDay] = useState(false);
  const [showShareReport, setShowShareReport] = useState(false);
  const [isFilterClosing, setIsFilterClosing] = useState(false);
  const [showLinkDriveDialog, setShowLinkDriveDialog] = useState(false);
  const [showUnlinkDriveDialog, setShowUnlinkDriveDialog] = useState(false);
  const [driveLoading, setDriveLoading] = useState(false);
  const [isDriveLinked, setIsDriveLinked] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const dateRangeCalendarRef = useRef();
  const itemsPerPage = 10;
  const calendarRef = useRef();
  const accountMenuRef = useRef();
  const contentRef = useRef();

  const isMobile = shouldUseMobileLayout();
  const isInitialMount = useRef(true);

  // Refresh handler using shared refresh function
  const handleRefresh = async () => {
    if (isRefreshing) return; // Prevent multiple simultaneous refreshes

    try {
      await handleMobileRefresh({
        userId: user?.uid,
        dispatch,
        setRefreshing: setIsRefreshing
      });
      console.log('✅ Renewals data refreshed');
    } catch (error) {
      console.error('❌ Error refreshing Renewals:', error);
    }
  };

  useEffect(() => {
    // Wait for useAdminStaffData to resolve admin status and staff UIDs
    if (staffLoading) return;

    // Admin → fetch aggregated policies for multiple users (including admin self)
    if (isAdmin && userIds.length > 0) {
      console.log('Admin user (Mobile) - fetching aggregated policies for renewals:', userIds);
      dispatch(fetchPoliciesForMultipleUsers(userIds));
      return;
    }

    // Normal staff user → fetch own policies ONLY
    if (user?.uid && !isAdmin) {
      console.log('Staff user (Mobile) - fetching own policies for renewals');
      dispatch(fetchPolicies(user.uid));
    }
  }, [user?.uid, dispatch, isAdmin, userIds, staffLoading]);

  // Restore filter state and selectedDate from sessionStorage on mount
  useEffect(() => {
    const savedFilters = sessionStorage.getItem('mobileRenewals_filterState');
    if (savedFilters) {
      try {
        const filters = JSON.parse(savedFilters);
        setSelectedCompanies(filters.selectedCompanies || []);
        setSelectedStatuses(filters.selectedStatuses || []);
        setShowCompanyOptions(filters.showCompanyOptions || false);
        setShowStatusOptions(filters.showStatusOptions || false);
        if (filters.dateRange) {
          setDateRange({
            start: filters.dateRange.start ? dayjs(filters.dateRange.start) : null,
            end: filters.dateRange.end ? dayjs(filters.dateRange.end) : null
          });
        }
        // Restore selectedDate
        if (filters.selectedDate) {
          setSelectedDate(dayjs(filters.selectedDate));
        }
      } catch (error) {
        console.error('Error restoring filter state:', error);
      }
    }
    // Delay setting isInitialMount to false to ensure all state updates complete
    setTimeout(() => {
      isInitialMount.current = false;
    }, 100);
  }, []); // Run only on mount

  // Save filter state and selectedDate to sessionStorage whenever they change (but not on initial mount)
  useEffect(() => {
    // Skip saving on initial mount to avoid overwriting with empty state
    if (isInitialMount.current) {
      return;
    }

    const filterState = {
      selectedCompanies,
      selectedStatuses,
      showCompanyOptions,
      showStatusOptions,
      dateRange: {
        start: dateRange.start ? dateRange.start.format('YYYY-MM-DD') : null,
        end: dateRange.end ? dateRange.end.format('YYYY-MM-DD') : null
      },
      selectedDate: selectedDate ? selectedDate.format('YYYY-MM-DD') : null
    };
    sessionStorage.setItem('mobileRenewals_filterState', JSON.stringify(filterState));
  }, [selectedCompanies, selectedStatuses, showCompanyOptions, showStatusOptions, dateRange, selectedDate]);

  // Restore date from navigation state
  useEffect(() => {
    if (location.state?.selectedDate) {
      setSelectedDate(dayjs(location.state.selectedDate));
    }
  }, [location.state]);

  // Check for initial Drive status on mount
  useEffect(() => {
    if (isAdmin && user?.uid) {
      checkDriveStatus().then(status => {
        setIsDriveLinked(status.linked);
      }).catch(err => console.error('Error checking drive status:', err));
    }
  }, [isAdmin, user?.uid]);

  // Scroll to top when date or filters change
  useEffect(() => {
    if (!isInitialMount.current && contentRef.current) {
      contentRef.current.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [selectedDate, selectedCompanies, selectedStatuses, dateRange]);

  useEffect(() => {
    // Generate 7 days starting from the selected date
    const startDate = dayjs(selectedDate).startOf('week'); // Start from Sunday
    const dates = [];
    for (let i = 0; i < 7; i++) { // 7 days of the week
      dates.push(startDate.add(i, "day"));
    }
    setWeekDates(dates);
  }, [selectedDate]);

  // Handle click outside calendar dropdown and account menu
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
      if (accountMenuRef.current && !accountMenuRef.current.contains(e.target)) {
        setShowAccountMenu(false);
      }
      // Close date range calendar if clicking outside the filter popover
      if (dateRangeCalendarRef.current && !dateRangeCalendarRef.current.contains(e.target) && filterAnchorEl) {
        setShowDateRangeCalendar(false);
      }
      // Close filter box if clicking outside
      if (filterAnchorEl && e.target !== filterAnchorEl && !e.target.closest('[role="button"]')) {
        const filterBox = document.querySelector('[data-filter-box]');
        if (filterBox && !filterBox.contains(e.target)) {
          handleFilterClose();
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [filterAnchorEl]);

  const weekEnd = selectedDate.add(6, 'day');

  const getStatusFromExpiry = (expiryDate, originalStatus = null) => {
    return calculatePolicyStatus(expiryDate, originalStatus);
  };

  const handleFilterButtonClick = (event) => {
    // If filter is already open, close it (same behavior as Done button)
    if (filterAnchorEl) {
      handleFilterClose();
    } else {
      setFilterAnchorEl(event.currentTarget);
      setIsFilterClosing(false);
    }
  };

  const handleFilterClose = () => {
    setIsFilterClosing(true);
    // Wait for animation to complete before actually closing
    setTimeout(() => {
      setFilterAnchorEl(null);
      setIsFilterClosing(false);
    }, 200); // Match the collapse animation duration
  };

  const handleCompanyToggle = (company) => {
    setSelectedCompanies((prev) =>
      prev.includes(company)
        ? prev.filter((c) => c !== company)
        : [...prev, company]
    );
  };

  const handleStatusToggle = (status) => {
    setSelectedStatuses((prev) =>
      prev.includes(status)
        ? prev.filter((s) => s !== status)
        : [...prev, status]
    );
  };

  const handleDateRangeCalendarChange = (date) => {
    const selectedDay = dayjs(date);

    if (showDateRangeCalendar === 'start') {
      // Setting start date
      setDateRange({
        start: selectedDay,
        end: dateRange.end && selectedDay.isAfter(dateRange.end) ? null : dateRange.end
      });
      // Automatically switch to end date selection if end is not set
      if (!dateRange.end) {
        setShowDateRangeCalendar('end');
      }
    } else if (showDateRangeCalendar === 'end') {
      // Setting end date
      // Validation: end date cannot be before start date
      if (selectedDay.isBefore(dateRange.start, 'day')) {
        return;
      }
      setDateRange((prev) => ({
        start: prev.start,
        end: selectedDay
      }));
      // Close calendar after end date is selected
      setShowDateRangeCalendar(null);
    }
  };

  const clearFilters = () => {
    setSelectedCompanies([]);
    setDateRange({ start: null, end: null });
    setSelectedStatuses([]);
    setShowStatusOptions(false);
    setShowCompanyOptions(false);
  };

  const companyOptions = Array.from(new Set([
    ...COMPANIES.motor,
    ...COMPANIES.life,
    ...COMPANIES.non_motor
  ])).sort();
  const dateRangeActive = Boolean(dateRange.start && dateRange.end);
  const activeFilterCount = selectedCompanies.length + (dateRangeActive ? 1 : 0) + (selectedStatuses.length > 0 ? 1 : 0);

  const getCalendarConfig = () => {
    try {
      const testDate = new Date();
      const testLocale = testDate.toLocaleDateString('en');
      return {
        calendarType: 'gregory',
        locale: 'en',
        maxDetail: 'month',
        minDetail: 'month'
      };
    } catch (error) {
      console.warn('Calendar locale detection failed, using fallback:', error);
      return {
        calendarType: 'gregory',
        locale: undefined,
        maxDetail: 'month',
        minDetail: 'month'
      };
    }
  };

  const handleDayShift = (direction) => {
    if (dateRange.start && dateRange.end) return;

    if (showSingleDay) {
      // Navigate by single day
      setSelectedDate((prev) =>
        direction === 'prev' ? prev.subtract(1, 'day') : prev.add(1, 'day')
      );
    } else {
      // Navigate by week
      setSelectedDate((prev) =>
        direction === 'prev' ? prev.subtract(7, 'day').startOf('week') : prev.add(7, 'day').startOf('week')
      );
    }
  };

  // Filter policies based on the selected week or date range
  const filteredPolicies = policies.filter((p) => {
    if (!p.expiryDate) return false;

    const parsedDate = parseDate(p.expiryDate);
    if (!parsedDate || isNaN(parsedDate.getTime())) {
      return false;
    }

    const expiry = dayjs(parsedDate).startOf('day');
    if (!expiry.isValid()) return false;

    const rangeStart = dateRange.start?.startOf('day');
    const rangeEnd = dateRange.end?.startOf('day');
    const weekStart = selectedDate.startOf('day');
    const weekEndDay = weekEnd.startOf('day');

    let matchesRange;
    if (rangeStart && rangeEnd) {
      matchesRange = expiry.isSameOrAfter(rangeStart) && expiry.isSameOrBefore(rangeEnd);
    } else if (showSingleDay) {
      matchesRange = expiry.isSame(weekStart);
    } else {
      matchesRange = expiry.isSameOrAfter(weekStart) && expiry.isSameOrBefore(weekEndDay);
    }

    if (!matchesRange) return false;

    if (selectedCompanies.length > 0 && !selectedCompanies.includes(p.policyCompany)) {
      return false;
    }

    if (selectedStatuses.length > 0) {
      const status = getStatusFromExpiry(p.expiryDate, p.status);
      if (!selectedStatuses.includes(status)) {
        return false;
      }
    }

    return true;
  }).sort((a, b) => {
    const aDate = dayjs(parseDate(a.expiryDate));
    const bDate = dayjs(parseDate(b.expiryDate));
    if (!aDate.isValid() || !bDate.isValid()) return 0;
    return aDate.diff(bDate);
  });

  // Initialize displayed policies when filters change
  useEffect(() => {
    // Do not set displayed policies until initial data load has completed
    if (!initialized) return;

    // Show ALL policies initially, not just first page
    setDisplayedPolicies(filteredPolicies);
    setHasMore(false); // No more to load since we're showing all
  }, [selectedDate, policies.length, initialized, dateRange.start, dateRange.end, selectedCompanies.join(','), selectedStatuses.join(','), showSingleDay]);

  // Infinite scroll handler
  const loadMorePolicies = useCallback(() => {
    if (isLoading || !hasMore) return;

    setIsLoading(true);
    setTimeout(() => {
      setDisplayedPolicies(prev => {
        const currentLength = prev.length;
        // Recalculate filtered policies inside the callback to get fresh data
        const currentFilteredPolicies = policies.filter((p) => {
          const expiryDate = dayjs(p.expiryDate);
          const selected = dayjs(selectedDate);
          return expiryDate.isSame(selected, 'day');
        });
        const nextPolicies = currentFilteredPolicies.slice(currentLength, currentLength + itemsPerPage);

        if (nextPolicies.length > 0) {
          setHasMore(currentLength + nextPolicies.length < currentFilteredPolicies.length);
          return [...prev, ...nextPolicies];
        } else {
          setHasMore(false);
          return prev;
        }
      });
      setIsLoading(false);
    }, 300);
  }, [isLoading, hasMore, policies, selectedDate, itemsPerPage]);

  // Scroll event handler
  useEffect(() => {
    const handleScroll = () => {
      if (!contentRef.current) return;

      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isNearBottom && hasMore && !isLoading) {
        loadMorePolicies();
      }
    };

    const contentElement = contentRef.current;
    if (contentElement) {
      contentElement.addEventListener('scroll', handleScroll);
      return () => contentElement.removeEventListener('scroll', handleScroll);
    }
  }, [hasMore, isLoading, loadMorePolicies]);

  // Show loading state until data is actually loaded
  if (loading || !initialized) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <Typography>Loading policies...</Typography>
      </Box>
    );
  }

  const handleFabMenuOpen = (event) => {
    setFabMenuAnchor(event.currentTarget);
  };

  const handleFabMenuClose = () => {
    setFabMenuAnchor(null);
  };

  const handleAddPolicy = () => {
    setShowModal(true);
    handleFabMenuClose();
  };

  const handleUploadPolicy = () => {
    // Clear any cached file data before opening the modal
    if (window.caches) {
      caches.keys().then((names) => {
        names.forEach(name => {
          if (name.includes('upload') || name.includes('pdf')) {
            caches.delete(name);
          }
        });
      });
    }

    // Clear any stored file references in localStorage
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.includes('upload') || key.includes('pdf') || key.includes('file'))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));

    setShowUploadModal(true);
    handleFabMenuClose();
  };

  const handleAccountMenuOpen = () => {
    setShowAccountMenu(true);
  };

  const handleAccountMenuClose = () => {
    setShowAccountMenu(false);
  };

  const handleEditAccount = () => {
    setShowEditAccount(true);
    handleAccountMenuClose();
  };

  const handleManageStaff = () => {
    setShowStaffDialog(true);
    handleAccountMenuClose();
  };

  // Handle Link Drive menu click
  const handleLinkDriveClick = () => {
    handleAccountMenuClose();
    if (isDriveLinked) {
      setShowUnlinkDriveDialog(true);
    } else {
      setShowLinkDriveDialog(true);
    }
  };

  // Confirm link drive action
  const confirmLinkDrive = async () => {
    try {
      setDriveLoading(true);
      const authUrl = await getDriveAuthUrl('mobile');
      // Redirect to Google OAuth
      window.location.href = authUrl;
    } catch (err) {
      console.error('Error getting auth URL:', err);
      toast.error(err.message || 'Failed to start Google Drive connection', { containerId: 'bottom-center' });
      setDriveLoading(false);
      setShowLinkDriveDialog(false);
    }
  };

  // Confirm unlink drive action
  const confirmUnlinkDrive = async () => {
    try {
      setDriveLoading(true);
      const { unlinkDrive } = await import("../../utils/driveApi");
      await unlinkDrive();
      setIsDriveLinked(false);
      toast.success('Successfully disconnected Google Drive', {
        containerId: 'bottom-center',
        position: 'bottom-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        closeButton: false,
        style: {
          backgroundColor: '#166434',
          color: '#FFFFFF',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: 500,
          padding: '12px 16px',
          minHeight: '44px',
          alignItems: 'center',
          gap: '10px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          marginBottom: window.innerWidth <= 1024 ? '75vh' : '20px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: 'auto',
          maxWidth: 'none',
          display: 'inline-flex',
        },
        icon: (
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ color: '#FFFFFF' }}
          >
            <path
              d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      });
      setShowUnlinkDriveDialog(false);
    } catch (err) {
      console.error('Error unlinking drive:', err);
      toast.error(err.message || 'Failed to disconnect Google Drive', { containerId: 'bottom-center' });
    } finally {
      setDriveLoading(false);
    }
  };

  const handleLogout = () => {
    setShowLogoutDialog(true);
    handleAccountMenuClose();
  };

  const confirmLogout = () => {
    dispatch(logoutUser());
    navigate('/login');
    setShowLogoutDialog(false);
  };

  const cancelLogout = () => {
    setShowLogoutDialog(false);
  };

  const getPolicyIcon = (policy) => {
    if (policy.policyCategory === 'motor') {
      return <DirectionsCarIcon sx={{ fontSize: 20, color: '#626B77' }} />;
    } else if (policy.policyCategory === 'health') {
      return <FavoriteIcon sx={{ fontSize: 20, color: '#626B77' }} />;
    } else if (policy.policyCategory === 'life') {
      return <SecurityIcon sx={{ fontSize: 20, color: '#626B77' }} />;
    }
    return <SecurityIcon sx={{ fontSize: 20, color: '#626B77' }} />;
  };

  // Handle phone call
  const handlePhoneCall = (policy, event) => {
    event.stopPropagation();
    if (policy?.mobile) {
      window.location.href = `tel:${policy.mobile}`;
    }
  };

  // Format date to "25 Oct 2025" format
  const formatDateForMessage = (dateInput) => {
    const parsedDate = parseDate(dateInput);
    if (!parsedDate || isNaN(parsedDate.getTime())) return "";
    const day = parsedDate.getDate();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[parsedDate.getMonth()];
    const year = parsedDate.getFullYear();
    return `${day} ${month} ${year}`;
  };

  // Generate WhatsApp message for renewals
  const generateRenewalMessage = async (policy) => {
    const expiryDate = parseDate(policy.expiryDate);
    if (!expiryDate || isNaN(expiryDate.getTime())) return "";

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiry = new Date(expiryDate);
    expiry.setHours(0, 0, 0, 0);

    const isExpired = today > expiry;
    const formattedDate = formatDateForMessage(policy.expiryDate);
    const policyType = policy.policyType || "Policy";
    const companyName = policy.policyCompany || "your insurer";
    const vehicleMake = policy.vehicleMake || "";
    const isMotor = policy.policyCategory === "motor";
    const vehicleModel = policy.vehicleModel || "";
    const vehicleNumber = policy.vehicleNumber || "";
    const clientName = policy.name || "";
    const greeting = clientName ? `Hi ${clientName}` : "Hi";

    let message = "";
    // Get agent details from Firestore
    let agentName = 'your agent';
    let agentMobile = '';

    try {
      const agentDoc = await getDoc(doc(db, 'agent-details', user.uid));
      if (agentDoc.exists()) {
        const agentData = agentDoc.data();
        agentName = agentData.name || agentData.displayName || 'your agent';
        agentMobile = agentData.phone || agentData.phoneNumber || '';
      }
    } catch (error) {
      console.error('Error fetching agent details:', error);
    }
    if (isExpired) {
      // Expired templates
      if (isMotor && vehicleModel && vehicleNumber && vehicleMake) {
        message = `${greeting}\nYour *${policyType} policy* for ${vehicleMake} ${vehicleModel} - *${vehicleNumber}* with ${companyName} expired on *${formattedDate}*⚠️\n\nPlease reply here or give a quick call to your agent: ${agentName} at ${agentMobile} to renew it.`;
      } else if (isMotor && vehicleNumber) {
        message = `${greeting}\nYour *${policyType} policy* , *${vehicleNumber}* with ${companyName} expired on *${formattedDate}*⚠️\n\nPlease reply here or give a quick call to your agent: ${agentName} at ${agentMobile} to renew it.`;
      } else {
        message = `${greeting}\nYour *${policyType}* with ${companyName} expired on *${formattedDate}*⚠️\n\nPlease reply here or give a quick call to your agent: ${agentName} at ${agentMobile} to renew it.`;
      }
    } else {
      // Due for renewal templates
      if (isMotor && vehicleModel && vehicleNumber, vehicleMake) {
        message = `${greeting}\nYour *${policyType} policy* for ${vehicleMake} ${vehicleModel} - *${vehicleNumber}* with ${companyName} is due for renewal on *${formattedDate}* ⏳\n\nPlease reply here or give a quick call to your agent: ${agentName} at ${agentMobile} to renew it before due date`;
      } else if (isMotor && vehicleNumber) {
        message = `${greeting}\nYour *${policyType} policy* , *${vehicleNumber}* with ${companyName} is due for renewal on *${formattedDate}* ⏳\n\nPlease reply here or give a quick call to your agent: ${agentName} at ${agentMobile} to renew it before due date`;
      } else {
        message = `${greeting}\nYour *${policyType}* with ${companyName} is due for renewal on *${formattedDate}* ⏳\n\nPlease reply here or give a quick call to your agent: ${agentName} at ${agentMobile} to renew it before due date`;
      }
    }

    return message;
  };

  // Handle WhatsApp redirect
  const handleWhatsAppRedirect = (message) => {
    if (!message) {
      console.error("No message provided for WhatsApp");
      return;
    }

    const whatsappAppUrl = `whatsapp://send?text=${encodeURIComponent(message)}`;
    const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIos) {
      // For iOS, use direct window.location.href
      // This will open the app if installed, or do nothing if not
      window.location.href = whatsappAppUrl;

      // No fallback to web version as it was causing issues
      // User will stay in the app if it opens, or nothing happens if not installed
    } else {
      // For Android/other devices, use iframe approach
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = whatsappAppUrl;
      document.body.appendChild(iframe);

      // Remove iframe after a short delay
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 100);

      // No need for blur detection or fallback to web version
      // as it was causing the web version to open even when app was launched
    }
  };

  const handleRemindClick = (policy, event) => {
    event.stopPropagation();
    setSelectedPolicyForRemind(policy);
    setRemindDialogOpen(true);
  };

  const handleRemindConfirm = async () => {
    if (selectedPolicyForRemind) {
      try {
        const message = await generateRenewalMessage(selectedPolicyForRemind);
        handleWhatsAppRedirect(message);

        if (user?.uid) {
          await incrementActionCounter(user.uid, 'renewalremindercounter');
        }
      } catch (error) {
        console.error('Error generating renewal message:', error);
        // Fallback to a default message if there's an error
        handleWhatsAppRedirect("Your policy is due for renewal. Please contact your agent for more information.");
      }
    }
    setRemindDialogOpen(false);
    setSelectedPolicyForRemind(null);
  };

  const handleRemindClose = () => {
    setRemindDialogOpen(false);
    setSelectedPolicyForRemind(null);
  };


  return (
    <Box
      className="mobile-layout mobile-content-container"
      sx={{
        width: '100vw',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        overscrollBehavior: 'none'
      }}
    >

      {/* Header */}
      <Box sx={{
        backgroundColor: '#0063F7',
        px: { xs: 2, sm: 3, md: 4 },
        py: 1,
        height: 70,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000
      }}>
        <Typography variant="h6" sx={{
          color: 'white',
          fontWeight: 600,
          fontSize: fonts.header.xs
        }}>
          Renewal
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton
            onClick={handleRefresh}
            disabled={isRefreshing}
            sx={{
              color: 'white',
              '&:disabled': {
                opacity: 0.6
              },
              '&:active': {
                transform: 'none',
                backgroundColor: 'transparent'
              },
              transition: 'none',
              WebkitTapHighlightColor: 'transparent'
            }}
          >
          </IconButton>
          <IconButton
            sx={{
              color: 'white',
              '&:active': {
                transform: 'none',
                backgroundColor: 'transparent'
              },
              transition: 'none',
              WebkitTapHighlightColor: 'transparent'
            }}
            onClick={() => {
              setShowCalendar(!showCalendar);
              if (!showCalendar) {
                setShowSingleDay(false);
              }
            }}
          >
            <CalendarTodayIcon />
          </IconButton>
          {isAdmin && (
            <IconButton
              sx={{
                color: 'white',
                '&:active': {
                  transform: 'none',
                  backgroundColor: 'transparent'
                },
                transition: 'none',
                WebkitTapHighlightColor: 'transparent'
              }}
              onClick={() => setShowShareReport(true)}
            >
              <AssessmentIcon />
            </IconButton>
          )}
          <Avatar
            src={user?.photoURL}
            onClick={handleAccountMenuOpen}
            sx={{
              width: 32,
              height: 32,
              '&:active': {
                transform: 'none',
                backgroundColor: 'transparent'
              },
              transition: 'none',
              WebkitTapHighlightColor: 'transparent',
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8
              }
            }}
          >
            {user?.displayName?.charAt(0) || "A"}
          </Avatar>
        </Box>
      </Box>

      {/* Week Range Strip */}
      <Box sx={{
        backgroundColor: 'white',
        px: 1.25,
        py: 0.75,
        borderBottom: '1px solid #e0e0e0',
        position: 'fixed',
        top: 70,
        left: 0,
        right: 0,
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <IconButton
          onClick={() => handleDayShift('prev')}
          disabled={Boolean(dateRange.start && dateRange.end)}
          sx={{
            width: 36,
            height: 36,
            '&:hover': {
              color: '#004DC2',
              backgroundColor: '#F5F8FF'
            }
          }}
        >
          <ChevronLeftIcon />
        </IconButton>

        <Typography sx={{
          fontSize: '12px',
          fontWeight: 500,
          color: '#212121',
          flex: 1,
          textAlign: 'center'
        }}>
          {showSingleDay ? selectedDate.format('ddd,DD MMM') : `${selectedDate.format('ddd,DD MMM')} - ${weekEnd.format('ddd,DD MMM')}`}
        </Typography>

        <IconButton
          onClick={() => handleDayShift('next')}
          disabled={Boolean(dateRange.start && dateRange.end)}
          sx={{
            width: 36,
            height: 36,
            '&:hover': {
              color: '#004DC2',
              backgroundColor: '#F5F8FF'
            }
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>

      {/* Calendar Dropdown */}
      {showCalendar && (
        <Box
          ref={calendarRef}
          sx={{
            position: 'fixed',
            top: 110,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            zIndex: 1200,
            width: '95vw',
            maxWidth: 360,
            p: 2
          }}
        >
          {/* Calendar Header with Month/Year and Navigation */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}>
            <IconButton
              onClick={() => setCalendarMonth(calendarMonth.subtract(1, 'month'))}
              sx={{
                color: '#0063F7',
                '&:active': {
                  transform: 'none',
                  backgroundColor: 'transparent'
                },
                transition: 'none',
                WebkitTapHighlightColor: 'transparent'
              }}
            >
              <ChevronLeftIcon />
            </IconButton>
            <Typography sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#212121'
            }}>
              {calendarMonth.format('MMMM YYYY')}
            </Typography>
            <IconButton
              onClick={() => setCalendarMonth(calendarMonth.add(1, 'month'))}
              sx={{
                color: '#0063F7',
                '&:active': {
                  transform: 'none',
                  backgroundColor: 'transparent'
                },
                transition: 'none',
                WebkitTapHighlightColor: 'transparent'
              }}
            >
              <ChevronRightIcon />
            </IconButton>
          </Box>

          {/* Day Headers */}
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: 1,
            mb: 1
          }}>
            {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
              <Typography key={day} sx={{
                fontSize: '12px',
                fontWeight: 500,
                textAlign: 'center',
                color: '#757575'
              }}>
                {day}
              </Typography>
            ))}
          </Box>

          {/* Calendar Days */}
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: 1
          }}>
            {Array.from({ length: 42 }, (_, i) => {
              const startOfMonth = calendarMonth.startOf('month');
              const startOfCalendar = startOfMonth.subtract(startOfMonth.day(), 'day');
              const date = startOfCalendar.add(i, 'day');
              const isCurrentMonth = date.month() === calendarMonth.month();
              const isSelected = selectedDate.isSame(date, 'day');
              const isToday = date.isSame(dayjs(), 'day');

              return (
                <Box
                  key={i}
                  onClick={() => {
                    setSelectedDate(date);
                    setShowSingleDay(true);
                    setShowCalendar(false);
                  }}
                  sx={{
                    width: 32,
                    height: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    backgroundColor: isSelected ? '#0063F7' : isToday ? '#E0EBFF' : 'transparent',
                    color: isSelected ? 'white' : isToday ? '#0063F7' : isCurrentMonth ? '#212121' : '#757575',
                    fontSize: '14px',
                    fontWeight: isSelected || isToday ? 600 : 400,
                    '&:hover': {
                      backgroundColor: isSelected ? '#0063F7' : '#E0EBFF'
                    },
                    '&:active': {
                      transform: 'none',
                      backgroundColor: isSelected ? '#0063F7' : '#E0EBFF'
                    },
                    transition: 'none',
                    WebkitTapHighlightColor: 'transparent'
                  }}
                >
                  {date.date()}
                </Box>
              );
            })}
          </Box>
        </Box>
      )}

      {/* Account Menu Popup */}
      {showAccountMenu && (
        <Box
          ref={accountMenuRef}
          sx={{
            position: 'absolute',
            top: 60,
            right: 16,
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            zIndex: 1300,
            minWidth: 200,
            p: 1
          }}
        >
          {/* User Info */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            p: 2,
            borderBottom: '1px solid #e0e0e0'
          }}>
            <Avatar
              src={user?.photoURL}
              sx={{ width: 40, height: 40 }}
            >
              {user?.displayName?.charAt(0) || "A"}
            </Avatar>
            <Box>
              <Typography sx={{
                fontSize: fonts.title.xs,
                fontWeight: 600,
                color: '#212121'
              }}>
                {user?.displayName || "User"}
              </Typography>
              <Typography sx={{
                fontSize: fonts.body.xs,
                color: '#757575'
              }}>
                {user?.email}
              </Typography>
            </Box>
          </Box>

          {/* Menu Items */}
          <Box sx={{ p: 1 }}>
            <Box
              onClick={handleEditAccount}
              sx={{
                display: 'flex',
                alignItems: 'center',
                '&:active': {
                  transform: 'none',
                  backgroundColor: 'transparent'
                },
                transition: 'none',
                WebkitTapHighlightColor: 'transparent',
                gap: 2,
                p: 2,
                borderRadius: '8px',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#f5f5f5'
                }
              }}
            >
              <EditIcon sx={{ color: '#0063F7', fontSize: 20 }} />
              <Typography sx={{
                fontSize: '14px',
                color: '#212121'
              }}>
                Edit Account
              </Typography>
            </Box>
            {isAdmin && (
              <Box
                onClick={handleManageStaff}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  '&:active': {
                    transform: 'none',
                    backgroundColor: 'transparent'
                  },
                  transition: 'none',
                  WebkitTapHighlightColor: 'transparent',
                  gap: 2,
                  p: 2,
                  borderRadius: '8px',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: '#f5f5f5'
                  }
                }}
              >
                <PersonIcon sx={{ color: '#0063F7', fontSize: 20 }} />
                <Typography sx={{
                  fontSize: '14px',
                  color: '#212121'
                }}>
                  Manage Staff
                </Typography>
              </Box>
            )}
            {isAdmin && (
              <Box
                onClick={handleLinkDriveClick}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  '&:active': {
                    transform: 'none',
                    backgroundColor: 'transparent'
                  },
                  transition: 'none',
                  WebkitTapHighlightColor: 'transparent',
                  gap: 2,
                  p: 2,
                  borderRadius: '8px',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: '#f5f5f5'
                  }
                }}
              >
                <CloudIcon sx={{ color: isDriveLinked ? '#F04438' : '#0063F7', fontSize: 20 }} />
                <Typography sx={{
                  fontSize: '14px',
                  color: isDriveLinked ? '#F04438' : '#212121'
                }}>
                  {isDriveLinked ? 'Unlink Drive' : 'Link Drive'}
                </Typography>
              </Box>
            )}
            <Box
              onClick={handleLogout}
              sx={{
                display: 'flex',
                alignItems: 'center',
                '&:active': {
                  transform: 'none',
                  backgroundColor: 'transparent'
                },
                transition: 'none',
                WebkitTapHighlightColor: 'transparent',
                gap: 2,
                p: 2,
                borderRadius: '8px',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#f5f5f5'
                }
              }}
            >
              <LogoutIcon sx={{ color: '#F04438', fontSize: 20 }} />
              <Typography sx={{
                fontSize: '14px',
                color: '#F04438'
              }}>
                Logout
              </Typography>
            </Box>
          </Box>
        </Box>
      )}

      {/* Filter Popover */}
      {Boolean(filterAnchorEl) && (
        <Box
          data-filter-box="true"
          sx={{
            position: 'fixed',
            bottom: 170, // Position above FAB (FAB is at 100px + 56px height + 14px spacing)
            right: '2vw',
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            zIndex: 1300,
            width: '96vw',
            maxWidth: 500,
            maxHeight: 'calc(100vh - 250px)',
            overflowY: 'auto',
            p: 1.5,
            transformOrigin: 'bottom right',
            animation: isFilterClosing
              ? 'collapseToFab 0.2s ease-in forwards'
              : 'expandFromFab 0.3s ease-out',
            '@keyframes expandFromFab': {
              '0%': {
                opacity: 0,
                transform: 'scale(0.3)',
                transformOrigin: 'bottom right'
              },
              '100%': {
                opacity: 1,
                transform: 'scale(1)',
                transformOrigin: 'bottom right'
              }
            },
            '@keyframes collapseToFab': {
              '0%': {
                opacity: 1,
                transform: 'scale(1)',
                transformOrigin: 'bottom right'
              },
              '100%': {
                opacity: 0,
                transform: 'scale(0.3)',
                transformOrigin: 'bottom right'
              }
            }
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Stack spacing={1.5}>
            {/* Company Filter - Only show if user has multiple companies */}
            {(user?.hasMultipleCompanies !== false) && (
              <>
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showCompanyOptions}
                          onChange={(e) => {
                            setShowCompanyOptions(e.target.checked);
                            if (!e.target.checked) {
                              setSelectedCompanies([]);
                            }
                          }}
                        />
                      }
                      label={<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Company</Typography>}
                    />
                  </Box>
                  {showCompanyOptions && (
                    <Box sx={{ mt: 0.75, ml: 2 }}>
                      {companyOptions.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">
                          No companies available.
                        </Typography>
                      ) : (
                        <Box sx={{ maxHeight: 180, overflowY: 'auto', pr: 1 }}>
                          <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: 0.5
                          }}>
                            {companyOptions.map((company) => (
                              <FormControlLabel
                                key={company}
                                control={
                                  <Checkbox
                                    checked={selectedCompanies.includes(company)}
                                    onChange={() => handleCompanyToggle(company)}
                                    size="small"
                                    sx={{ p: 0.5 }}
                                  />
                                }
                                label={company}
                                sx={{
                                  margin: 0,
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: 12,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '100px'
                                  }
                                }}
                              />
                            ))}
                          </Box>
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>

                <Divider sx={{ my: 0.75 }} />
              </>
            )}

            {/* Status Filter */}
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showStatusOptions}
                      onChange={(e) => {
                        setShowStatusOptions(e.target.checked);
                        if (!e.target.checked) {
                          setSelectedStatuses([]);
                        }
                      }}
                    />
                  }
                  label={<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Status</Typography>}
                />
              </Box>
              {showStatusOptions && (
                <Box sx={{ mt: 0.75, ml: 2 }}>
                  <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 0.5
                  }}>
                    {['Expired', 'Active', 'New lead'].map((status) => (
                      <FormControlLabel
                        key={status}
                        control={
                          <Checkbox
                            checked={selectedStatuses.includes(status)}
                            onChange={() => handleStatusToggle(status)}
                            size="small"
                            sx={{ p: 0.5 }}
                          />
                        }
                        label={status}
                        sx={{
                          margin: 0,
                          '& .MuiFormControlLabel-label': {
                            fontSize: 12,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '100px'
                          }
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}
            </Box>

            <Divider sx={{ my: 0.75 }} />

            {/* Date Range Filter */}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                Date range
              </Typography>
              <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                <Button
                  variant={showDateRangeCalendar === 'start' ? 'contained' : 'outlined'}
                  size="small"
                  onClick={() => setShowDateRangeCalendar(showDateRangeCalendar === 'start' ? null : 'start')}
                  sx={{
                    flex: 1,
                    fontSize: '0.75rem',
                    '&:hover': {
                      backgroundColor: showDateRangeCalendar === 'start' ? '#0056d6' : '#E0EBFF',
                      borderColor: '#E0EBFF'
                    }
                  }}
                >
                  {dateRange.start ? dateRange.start.format('DD MMM') : 'START'}
                </Button>
                <Button
                  variant={showDateRangeCalendar === 'end' ? 'contained' : 'outlined'}
                  size="small"
                  onClick={() => {
                    if (dateRange.start) {
                      setShowDateRangeCalendar(showDateRangeCalendar === 'end' ? null : 'end');
                    }
                  }}
                  sx={{
                    flex: 1,
                    fontSize: '0.75rem',
                    '&:hover': {
                      backgroundColor: showDateRangeCalendar === 'end' ? '#0056d6' : '#E0EBFF',
                      borderColor: '#E0EBFF'
                    }
                  }}
                  disabled={!Boolean(dateRange.start)}
                >
                  {dateRange.end ? dateRange.end.format('DD MMM') : 'END'}
                </Button>
              </Stack>
              {showDateRangeCalendar && (
                <Box
                  ref={dateRangeCalendarRef}
                  sx={{
                    position: 'relative',
                    zIndex: 1300,
                    boxShadow: 3,
                    borderRadius: 2,
                    bgcolor: 'background.paper',
                    width: '100%',
                    overflow: 'hidden',
                    padding: '6px',
                    mt: 1,
                    '& .react-calendar': {
                      width: '100%',
                      maxWidth: '100%',
                      minHeight: '160px',
                      '&__navigation': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 2px',
                        margin: '0 0 4px 0',
                        '&__label': {
                          minWidth: '110px',
                          textAlign: 'center',
                          flexGrow: 0,
                          fontWeight: '600 !important',
                          margin: 0,
                          padding: '2px 0',
                          fontSize: '12px',
                          lineHeight: '1.1'
                        },
                        '&__arrow': {
                          minWidth: '24px',
                          padding: '2px 0px',
                          margin: 0,
                          fontSize: '16px'
                        }
                      },
                      '&__month-view__weekdays': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '0 2px',
                        marginBottom: '1px',
                        '&__weekday': {
                          width: '26px',
                          padding: '1px 0',
                          textAlign: 'center',
                          fontSize: '9px',
                          fontWeight: '600 !important',
                          textTransform: 'uppercase',
                          color: '#666 !important',
                          backgroundColor: 'transparent !important',
                          border: 'none !important',
                          '& abbr': {
                            textDecoration: 'none',
                            display: 'inline-block',
                            width: '100%',
                            textAlign: 'center'
                          }
                        }
                      },
                      '&__month-view__days': {
                        display: 'grid !important',
                        gridTemplateColumns: 'repeat(7, 1fr)',
                        gap: '1px',
                        padding: '0 2px',
                        '&__day': {
                          width: '26px',
                          height: '26px',
                          margin: '0 auto',
                          fontWeight: '600 !important',
                          padding: '0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '10px',
                          '&--neighboringMonth': {
                            opacity: 0.5
                          },
                          '&--weekend': {
                            color: '#212121 !important'
                          },
                          '&--now': {
                            fontWeight: 'bold',
                            color: '#004DC2 !important',
                            backgroundColor: 'transparent !important',
                            '&:enabled:hover': {
                              backgroundColor: '#E0EBFF !important'
                            }
                          }
                        }
                      }
                    },
                    '& .react-calendar__tile': {
                      fontFamily: 'Roboto',
                      fontWeight: 500,
                      fontSize: '13px',
                      color: '#212121 !important',
                      transition: 'all 0.2s ease',
                      '&:enabled:hover': {
                        backgroundColor: '#E0EBFF !important',
                        color: '#212121 !important'
                      },
                      '&--active, &--active:enabled, &--active:enabled:hover': {
                        backgroundColor: '#004DC2 !important',
                        color: '#fff !important',
                        borderRadius: '50%',
                        border: 'none',
                        boxShadow: 'none',
                        outline: 'none'
                      }
                    },
                    "& .react-calendar__tile--active, & .react-calendar__tile--active:enabled": {
                      backgroundColor: '#004DC2 !important',
                      color: '#fff !important',
                    },
                    "& .react-calendar__month-view__days__day--weekend": {
                      color: '#212121 !important',
                    },
                    "& .react-calendar__tile:not(.react-calendar__tile--active):enabled:hover": {
                      backgroundColor: '#E0EBFF !important',
                    },
                    "& .react-calendar__navigation button": {
                      color: '#333 !important',
                      background: 'none !important',
                      fontWeight: '600 !important',
                      border: 'none !important',
                      outline: 'none !important',
                      '&:hover': {
                        backgroundColor: '#E0EBFF !important',
                        color: '#333 !important',
                      },
                      '&:focus': {
                        backgroundColor: 'transparent !important',
                        outline: 'none !important',
                        boxShadow: 'none !important',
                      },
                      '&:active': {
                        backgroundColor: 'transparent !important',
                      },
                    },
                    "& .react-calendar__navigation__label": {
                      color: '#333 !important',
                      background: 'transparent !important',
                      fontWeight: '600 !important',
                      '&:hover': {
                        backgroundColor: 'transparent !important',
                      },
                      '&:focus': {
                        backgroundColor: 'transparent !important',
                        outline: 'none !important',
                      },
                    },
                  }}
                >
                  {(() => {
                    try {
                      return (
                        <Calendar
                          value={dateRange.start?.toDate() || dateRange.end?.toDate()}
                          onChange={handleDateRangeCalendarChange}
                          {...getCalendarConfig()}
                        />
                      );
                    } catch (error) {
                      console.error('Date range calendar rendering failed:', error);
                      return (
                        <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
                          Calendar could not be loaded.
                        </Box>
                      );
                    }
                  })()}
                </Box>
              )}
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                {showDateRangeCalendar ? `Select date` : 'Click to select date range'}
              </Typography>
            </Box>

            <Divider sx={{ my: 0.75 }} />

            {/* Action Buttons */}
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button
                onClick={clearFilters}
                size="small"
                color="inherit"
                sx={{
                  flex: 1,
                  '&:hover': {
                    backgroundColor: '#F5F8FF'
                  }
                }}
              >
                Clear filters
              </Button>
              <Button
                onClick={handleFilterClose}
                size="small"
                variant="contained"
                sx={{
                  flex: 1
                }}
              >
                Done
              </Button>
            </Stack>
          </Stack>
        </Box>
      )}

      {/* Policies List */}
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          py: 2,
          pb: 10,
          mt: '125px',
          overflowX: 'hidden',
          backgroundColor: '#f5f5f5'
        }}
      >
        {displayedPolicies.length > 0 ? (
          <Box sx={{ width: '100%' }}>
            {displayedPolicies.map((policy) => {
              const statusText = calculatePolicyStatus(policy.expiryDate, policy.status);

              return (
                <Paper
                  key={policy.id}
                  onClick={() => {
                    navigate(`/policy/${policy.id}`, { state: { policy, fromScreen: 'renewals', selectedDate: selectedDate.format('YYYY-MM-DD') } });
                  }}
                  sx={{
                    '&:active': {
                      transform: 'none',
                      backgroundColor: '#E0EBFF'
                    },
                    WebkitTapHighlightColor: 'transparent',
                    p: { xs: 1, sm: 1.5, md: 2 },
                    mb: 1.5,
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    width: '100%',
                    minWidth: '100%',
                    maxWidth: '100%',
                    flex: '1 1 100%',
                    '&:hover': {
                      transform: 'translateY(-1px)',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                    }
                  }}
                >
                  {/* Company Name */}
                  <Typography sx={{
                    fontSize: fonts.small.xs,
                    fontWeight: 600,
                    color: '#0063F7',
                    mb: 0.8,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}>
                    {policy.policyCompany || 'Insurance Company'}
                  </Typography>

                  {/* 2 Column Layout */}
                  <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '3fr 1fr',
                    gap: { xs: 0.5, sm: 1 },
                    alignItems: 'flex-start',
                    width: '100%',
                    overflow: 'hidden'
                  }}>
                    {/* Column 1: Policy Details */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, minWidth: 0, overflow: 'hidden' }}>
                      <Box sx={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
                        {policy.policyCategory === 'motor' ? (
                          <>
                            <Typography sx={{
                              fontSize: '16px !important',
                              fontWeight: 500,
                              color: '#212121',
                              mb: 0.3,
                              lineHeight: 1.2,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              '&.MuiTypography-root': {
                                fontSize: '16px !important'
                              }
                            }}>
                              {policy.vehicleMake && policy.vehicleModel ?
                                `${policy.vehicleMake} ${policy.vehicleModel}`.trim() :
                                (policy.vehicleMake || policy.vehicleModel || 'Vehicle')
                              }
                            </Typography>
                            <Typography sx={{
                              fontSize: '14px !important',
                              color: '#757575',
                              lineHeight: 1.1,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              '&.MuiTypography-root': {
                                fontSize: '14px !important'
                              }
                            }}>
                              {policy.vehicleNumber || 'N/A'}
                            </Typography>
                          </>
                        ) : (
                          <>
                            <Typography sx={{
                              fontSize: '16px !important',
                              fontWeight: 500,
                              color: '#212121',
                              mb: 0.3,
                              lineHeight: 1.2,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              '&.MuiTypography-root': {
                                fontSize: '16px !important'
                              }
                            }}>
                              {policy.policyType || 'Policy'}
                            </Typography>
                            <Typography sx={{
                              fontSize: '14px !important',
                              color: '#757575',
                              lineHeight: 1.1,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              '&.MuiTypography-root': {
                                fontSize: '14px !important'
                              }
                            }}>
                              ₹ {policy.premiumAmount ? policy.premiumAmount.toLocaleString() : '0'}
                            </Typography>
                          </>
                        )}
                      </Box>
                    </Box>

                    {/* Column 2: Status */}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <StatusBadge
                        status={statusText}
                        size="small"
                      />
                    </Box>
                  </Box>

                  {/* Action Buttons Row */}
                  <Box sx={{
                    display: 'flex',
                    gap: 2.5,
                    mt: 1.5,
                    width: '100%',
                    justifyContent: 'flex-start'
                  }}>
                    {/* Call Button */}
                    <Button
                      onClick={(e) => handlePhoneCall(policy, e)}
                      disabled={!policy?.mobile}
                      sx={{
                        flex: 1,
                        height: '22px',
                        borderRadius: '4px',
                        backgroundColor: '#0063F7 !important',
                        color: '#fff !important',
                        fontSize: '10px !important',
                        fontFamily: 'Roboto',
                        fontWeight: 500,
                        textTransform: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.3,
                        px: 0.5,
                        py: 0,
                        minWidth: 0
                      }}
                      className="mobile-button-override"
                    >
                      <PhoneIcon sx={{ fontSize: '12px' }} />
                      Call
                    </Button>

                    {/* Remind Button */}
                    <Button
                      onClick={(e) => handleRemindClick(policy, e)}
                      sx={{
                        flex: 1,
                        height: '22px',
                        borderRadius: '4px',
                        border: '1px solid #166434 !important',
                        backgroundColor: 'transparent !important',
                        color: '#166434 !important',
                        fontSize: '10px !important',
                        fontFamily: 'Roboto',
                        fontWeight: 500,
                        textTransform: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.3,
                        px: 0.5,
                        py: 0,
                        minWidth: 0
                      }}
                      className="mobile-button-override"
                    >
                      <NotificationsIcon sx={{ fontSize: '12px' }} />
                      Remind
                    </Button>
                  </Box>
                </Paper>
              );
            })}

            {/* Loading indicator */}
            {isLoading && (
              <Box sx={{ textAlign: 'center', py: 2 }}>
                <Typography sx={{ fontSize: '14px', color: '#757575' }}>
                  Loading more policies...
                </Typography>
              </Box>
            )}

          </Box>
        ) : (
          <Box sx={{
            textAlign: 'center',
            py: 4,
            color: '#757575'
          }}>
            <Typography sx={{ fontSize: '16px', mb: 1 }}>
              No renewals for this date
            </Typography>
            <Typography sx={{ fontSize: '14px' }}>
              Great time to follow up with new leads!
            </Typography>
          </Box>
        )}
      </Box>

      {/* Filter FAB Button */}
      <Box
        onClick={handleFilterButtonClick}
        sx={{
          position: 'fixed',
          bottom: 100, // Above the bottom navigation (80px height + 20px padding)
          right: { xs: 16, sm: 24 },
          width: { xs: 56, sm: 64 },
          height: { xs: 56, sm: 64 },
          backgroundColor: '#0063F7',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 16px rgba(0, 99, 247, 0.3)',
          zIndex: 1001,
          '&:active': {
            transform: 'scale(0.95)',
          },
          '&:hover': {
            backgroundColor: '#0051d4',
            boxShadow: '0 6px 20px rgba(0, 99, 247, 0.4)',
          },
        }}
      >
        <Badge
          color="primary"
          badgeContent={activeFilterCount}
          invisible={activeFilterCount === 0}
        >
          <FilterAltOutlinedIcon sx={{ fontSize: 24, color: 'white' }} />
        </Badge>
      </Box>

      {/* FAB Menu */}
      <Menu
        anchorEl={fabMenuAnchor}
        open={Boolean(fabMenuAnchor)}
        onClose={handleFabMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            minWidth: 200
          }
        }}
      >
        <MenuItem onClick={handleAddPolicy} sx={{ py: 1.5 }}>
          <AddIcon sx={{ mr: 2, color: '#0063F7' }} />
          <Typography>Add Policy</Typography>
        </MenuItem>
        <MenuItem
          onClick={isAccountActive ? handleUploadPolicy : undefined}
          disabled={!isAccountActive}
          sx={{ py: 1.5 }}
        >
          <UploadFileIcon sx={{ mr: 2, color: isAccountActive ? '#0063F7' : '#aaa' }} />
          <Typography>{isAccountActive ? 'Upload PDF' : 'Upload PDF (Disabled)'}</Typography>
        </MenuItem>
      </Menu>

      {/* Bottom Navigation */}
      <MobileBottomNavigation isAdmin={isAdmin} contentRef={contentRef} />

      {/* Modals */}
      <UploadPolicyModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onExtracted={(data) => {
          setPrefillData(data);
          setShowUploadModal(false);
          setShowModal(true);
        }}
        setShowSuccessDialog={setShowSuccessDialog}
        setPdfUrl={setSuccessPdfUrl}
      />
      {showModal && (
        <UnifiedPolicyForm
          isOpen={showModal}
          onClose={() => {
            setShowModal(false);
            setPrefillData(null);
          }}
          prefillData={prefillData}
          onSuccess={async (pdfUrl, formData) => {
            // Increment daily policy counter after successful save
            try {
              const { incrementDailyPolicyCounter } = await import("../../utils/dailyPolicyCounter");
              incrementDailyPolicyCounter(user.uid);
              console.log('📊 Daily policy counter incremented after successful save');
            } catch (error) {
              console.error('❌ Error incrementing daily policy counter:', error);
            }

            // Mark ALL screens for cache invalidation (Renewals write operation)
            const { firebaseCache } = await import("../../utils/firebaseCache");
            firebaseCache.invalidateAfterWrite('renewals_write', user.uid);

            // Re-fetch policies to ensure Redux state is updated for the report
            if (isAdmin && userIds.length > 0) {
              dispatch(fetchPoliciesForMultipleUsers(userIds));
            } else if (user?.uid && !isAdmin) {
              dispatch(fetchPolicies(user.uid));
            }

            if (pdfUrl) setSuccessPdfUrl(pdfUrl);
            if (formData) {
              setSuccessPremium(formData.amountPayable);
              setSuccessBalance(Math.max((Number(formData.amountPayable) || 0) - (Number(formData.paidAmount) || 0), 0));
            }
            setShowSuccessDialog(true);
          }}
        />
      )}
      <SuccessDialog
        isOpen={showSuccessDialog}
        pdfUrl={successPdfUrl}
        headerText="Policy Added Successfully"
        messageText="Policy has been successfully added. Share with customer via WhatsApp."
        agentName={user?.displayName || "Your Agent"}
        premiumAmount={successPremium}
        balanceAmount={successBalance}
        onClose={() => setShowSuccessDialog(false)}
      />

      {/* Edit Account Modal */}
      {showEditAccount && (
        <MobileEditAccount
          isOpen={showEditAccount}
          onClose={() => setShowEditAccount(false)}
          isAgentEdit={true}
          initialDetails={{
            name: user?.displayName || "",
            phone: user?.phone || "",
            email: user?.email || "",
            location: user?.address || ""
          }}
        />
      )}

      {/* Staff Management Modal */}
      <MobileStaffDialog
        isOpen={showStaffDialog}
        onClose={() => setShowStaffDialog(false)}
      />

      {/* Logout Confirmation Dialog */}
      <Dialog
        open={showLogoutDialog}
        onClose={cancelLogout}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            padding: '8px',
          }
        }}
      >
        <DialogContent sx={{ textAlign: 'left', pt: 3, pb: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: '18px',
              fontWeight: 500,
              color: '#1F2937',
              mb: 1
            }}
          >
            Are you sure you want to log out?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'right', gap: 0.5, pb: 3 }}>
          <Button
            onClick={cancelLogout}
            variant="outlined"
            sx={{
              width: "80px",
              height: "44px",
              borderRadius: "8px",
              borderColor: "#F04438",
              color: "#F04438",
              background: "#fff",
              fontFamily: "Roboto",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              letterSpacing: "0.01em",
              textTransform: "none",

            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmLogout}
            variant="contained"
            sx={{
              width: "90px",
              height: "44px",
              borderRadius: "8px",
              backgroundColor: "#F04438 !important",
              color: "#fff !important",
              fontFamily: "Roboto",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "24px",
              letterSpacing: "0.01em",
              textTransform: "none",
              boxShadow: "none",

            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>

      {/* Remind Dialog */}
      <RemindDialog
        isOpen={remindDialogOpen}
        onClose={handleRemindClose}
        onConfirm={handleRemindConfirm}
        message="Send renewal reminder via WhatsApp?"
      />

      <ShareReportDialog
        isOpen={showShareReport}
        onClose={() => setShowShareReport(false)}
        user={user}
        policies={policies}
        isAdmin={isAdmin}
      />

      {/* Link Drive Confirmation Dialog */}
      <Dialog
        open={showLinkDriveDialog}
        onClose={() => !driveLoading && setShowLinkDriveDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            width: '90vw',
            maxWidth: 400,
            p: 1
          }
        }}
      >
        <DialogContent sx={{ textAlign: 'center', pt: 3, pb: 2 }}>
          <CloudIcon sx={{ fontSize: 48, color: '#0063F7', mb: 2 }} />
          <Typography
            variant="h6"
            sx={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#1F2937',
              mb: 1
            }}
          >
            Connect Google Drive
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              color: '#6B7280',
              mb: 2
            }}
          >
            Link your Google Drive to store all policy PDFs securely. You will be redirected to Google to authorize access.
          </Typography>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#9CA3AF'
            }}
          >
            Only minimal "drive.file" permission is requested.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 1.5, pb: 3, px: 3 }}>
          <Button
            onClick={() => setShowLinkDriveDialog(false)}
            variant="outlined"
            disabled={driveLoading}
            sx={{
              flex: 1,
              height: "36px",
              borderRadius: "6px",
              fontSize: "14px",
              borderColor: "#B00020",
              color: "#B00020",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "inherit",
                color: "#B00020",
                boxShadow: 2
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmLinkDrive}
            variant="contained"
            disabled={driveLoading}
            sx={{
              flex: 1,
              height: "36px",
              borderRadius: "6px",
              fontSize: "14px",
              backgroundColor: "#0063F7 !important",
              color: "#fff !important",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#0051d4 !important",
              }
            }}
          >
            {driveLoading ? <CircularProgress size={20} color="inherit" /> : 'Connect Drive'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Disconnect Drive Confirmation Dialog */}
      <Dialog
        open={showUnlinkDriveDialog}
        onClose={() => !driveLoading && setShowUnlinkDriveDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            width: '90vw',
            maxWidth: 400,
            p: 1
          }
        }}
      >
        <DialogContent sx={{ textAlign: 'center', pt: 3, pb: 2 }}>
          <CloudIcon sx={{ fontSize: 48, color: '#F04438', mb: 2 }} />
          <Typography
            variant="h6"
            sx={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#1F2937',
              mb: 1
            }}
          >
            Disconnect Google Drive
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              color: '#6B7280',
              mb: 2
            }}
          >
            Are you sure you want to disconnect Google Drive? Staff will no longer be able to save policy PDFs to your Drive.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 1.5, pb: 3, px: 3 }}>
          <Button
            onClick={() => setShowUnlinkDriveDialog(false)}
            variant="outlined"
            disabled={driveLoading}
            sx={{
              flex: 1,
              height: "36px",
              borderRadius: "6px",
              fontSize: "14px",
              borderColor: "#F04438",
              color: "#F04438",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "inherit",
                color: "#F04438",
                boxShadow: 2
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmUnlinkDrive}
            variant="contained"
            disabled={driveLoading}
            sx={{
              flex: 1,
              height: "36px",
              borderRadius: "6px",
              fontSize: "14px",
              backgroundColor: "#F04438 !important",
              color: "#fff !important",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#D93C32 !important",
              }
            }}
          >
            {driveLoading ? <CircularProgress size={20} color="inherit" /> : 'Disconnect'}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default MobileRenewals;
